import Cookies from "js-cookie";
import LocalStorageUtils, { LocalStorageKey } from "./LocalStorageUtils";
export var Locale = /*#__PURE__*/function (Locale) {
  Locale["enUS"] = "en";
  Locale["zhCN"] = "zh-CN";
  Locale["zhTW"] = "zh-TW";
  Locale["ar"] = "ar";
  Locale["de"] = "de";
  Locale["es"] = "es";
  Locale["fr"] = "fr";
  Locale["id"] = "id";
  Locale["ja"] = "ja";
  Locale["ko"] = "ko";
  Locale["ms"] = "ms";
  Locale["pt"] = "pt";
  Locale["ru"] = "ru";
  Locale["th"] = "th";
  Locale["tr"] = "tr";
  Locale["vi"] = "vi";
  return Locale;
}({});
function toLocale(localeStr) {
  var _countryRegion$, _countryRegion$2;
  if (!localeStr) {
    return;
  }
  var locale;
  var countryRegion = localeStr.split(/-|_/);
  var country = (_countryRegion$ = countryRegion[0]) === null || _countryRegion$ === void 0 ? void 0 : _countryRegion$.toLowerCase();
  var region = (_countryRegion$2 = countryRegion[1]) === null || _countryRegion$2 === void 0 ? void 0 : _countryRegion$2.toUpperCase();
  if (country === "en") {
    locale = Locale.enUS;
  } else if (country === "zh") {
    if (region === "CN") {
      locale = Locale.zhCN;
    } else {
      locale = Locale.zhTW;
    }
  } else {
    locale = country;
  }
  return locale;
}

/**
 * 获取用户语言
 * 优先从页面链接中查找，查找到相应的
 * 1. 地址栏
 * 2. $cookie.locale || localStorage.locale
 * 3. acceptLanguage
 * 4. 默认语言
 */
export function getCurrentLocale() {
  var defaultLocale = Locale.enUS;
  var match = window.location.pathname.match(/^\/([^\/ ]+)/);
  var urlLocal = !!match && toLocale(match[1]);
  var storageLocale = toLocale(LocalStorageUtils.get(LocalStorageKey.CONFIG_LOCALE) || Cookies.get("locale") || "");
  var acceptLanguage = toLocale(window.navigator.language || window.navigator["browserLanguage"]);
  var locale = urlLocal || storageLocale || acceptLanguage || defaultLocale;
  return locale;
}